import styled from 'styled-components/macro';
import { desktopHover, pxtorem } from '~/utils/tools';

export const StyledFaqBlock = styled.div``;
